/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type SetAuthenticationHostRequestBody = {
  /**
   * The user_session_issuer id.
   */
  id: string;
  /**
   * True to move onto the authentication host, false to move off it.
   */
  useAuthenticationHost: boolean;
};

/** @internal */
export type SetAuthenticationHostRequestBody$Outbound = {
  id: string;
  use_authentication_host: boolean;
};

/** @internal */
export const SetAuthenticationHostRequestBody$outboundSchema: z.ZodMiniType<
  SetAuthenticationHostRequestBody$Outbound,
  SetAuthenticationHostRequestBody
> = z.pipe(
  z.object({
    id: z.string(),
    useAuthenticationHost: z.boolean(),
  }),
  z.transform((v) => {
    return remap$(v, {
      useAuthenticationHost: "use_authentication_host",
    });
  }),
);

export function setAuthenticationHostRequestBodyToJSON(
  setAuthenticationHostRequestBody: SetAuthenticationHostRequestBody,
): string {
  return JSON.stringify(
    SetAuthenticationHostRequestBody$outboundSchema.parse(
      setAuthenticationHostRequestBody,
    ),
  );
}
